module.exports = __webpack_public_path__ + "media/images/samples/home/top-n-1@2x-1477c78972735e9d1f309aacc60e118e.png";